import React from "react";
import styles from "./styles/assettype.module.css";
import { selectLogo } from "./selectLogo";
import useWindowDimensions from "../../Footer/footer";
function AssetType({
  asset_type,
  asset_name,
  removable = true,
  onDelete,
  list = false,
}) {
  const logo = selectLogo(asset_type);
  const { height, width } = useWindowDimensions();

  return (
    <div
      className={styles.main}
      style={
        list
          ? {
              width: "76%",
            }
          : {}
      }
    >
      <div
        className={styles.logo}
        style={{ backgroundImage: `url(${logo})` }}
      ></div>
      <div
        className={styles.text}
        style={
          {
            width: width > 590 ? "75%" : "",
            paddingRight: "10px",
            wordBreak: "break-all",
            height: "max-content",
            textOverflow: "ellipsis",
            overflow: "hidden",
            maxHeight: "2.5em",
            lineClamp: 2,
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            display: "-webkit-box",
          
          }
          // list
          //   ? {
          //       // width: "80%",
          //       paddingRight: "10px",
          //       wordBreak: "break-all",
          //       height: "max-content",
          //       textOverflow: "ellipsis",
          //       overflow: "hidden",
          //       maxHeight: "2.5em",
          //       lineClamp: 2,
          //       WebkitLineClamp: 2,
          //       WebkitBoxOrient: "vertical",
          //       display: "-webkit-box",
          //     }
          //   : {}
        }
      >
        {/* {list ? (
          asset_name.length >= 48 ? (
            <>{asset_name.slice(0, 48) + "..."}</>
          ) : (
            asset_name
          )
        ) : asset_name.length >= 34 ? (
          <>{asset_name.slice(0, 34) + "..."}</>
        ) : (
          asset_name
        )} */}
        {asset_name}
      </div>
      {removable ? (
        <div className={styles.delete_btn}>
          <div onClick={onDelete} className={styles.delete}></div>
        </div>
      ) : null}
    </div>
  );
}

export default AssetType;
